import { Block } from 'slate';
export default function groupCellsByRow(cells) {
  var rows = cells.reduce(function (rows, cell) {
    var node = Block.isBlock(cell) ? cell : cell.props.node;
    rows[rows.length - 1].push(cell);

    if (node.getIn(['data', 'rowBreak'])) {
      rows.push([]);
    }

    return rows;
  }, [[]]);

  if (!rows[rows.length - 1].length) {
    rows.pop();
  }

  return rows;
}